var parseOnClick = function (_a) {
    var onClick = _a.onClick, pageNumber = _a.pageNumber, isDisabled = _a.isDisabled;
    if (onClick && !isDisabled) {
        return function () { return onClick(pageNumber); };
    }
    return undefined;
};

export { parseOnClick as default };
